import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/dashboard_elements/stats');
  return response.data;
}

export default {
  index,
};
